// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__KSOrB","question":"NotFound_question__1vjg_","link":"NotFound_link__2VRig"};